var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVanskilaskraEkkiOk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "12px",
    viewBox: "0 0 14 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arion-New",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "EB\\xDE-RiskQ-nidurstodur-04",
    transform: "translate(-697.000000, -662.000000)",
    fill: "#0B45E6",
    stroke: "#0B45E6",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(534.000000, 655.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "169.415349 13.0019239 164.003821 18.451887 164.547877 19 170.000096 13.5090583 175.452314 19 175.99637 18.451887 170.585033 13.0019239 176 7.548113 175.455943 7 170.000287 12.4947895 164.544057 7.00019239 164 7.54830538"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVanskilaskraEkkiOk);
export default __webpack_public_path__ + "static/media/vanskilaskra-ekki-ok.b025ac0c4457c1963aa6d57c8a8ae217.svg";
export { ForwardRef as ReactComponent };